module.exports = require('../../full/object/iterate-entries');
